<template>
    <div class="info">
        <div class="fullname">
            {{ fullname }}
        </div>
        <div class="title" v-if="title">
            {{ title }}
        </div>
        <div class="details">
            <div class="detail">{{ phone }}</div>
            <div class="detail">{{ email }}</div>
            <div class="detail" v-if="url">{{ url }}</div>
            
        </div>
    </div>
</template>
<script>
export default{
    props:{
        fullname:{
            type: String
        },
        title:{
            type: String,
            required: false
        },
        email:{
            type: String
        },
        phone:{
            type: String
        },
        url:{
            type: String
        }

    }
}
</script>
<style scoped>
    .info{
        display: grid;
        grid-template-rows: auto auto auto;
    }

    .fullname, .title, .details{
        justify-self: center;
    }
    
    .fullname{
        font-size: 1.2rem;
        font-weight: bold;
        color: var(--tertiary);
    }

    .title{
        font-weight: bold;
    }

    .details{
        margin-top:0.5rem;
        display: flex;
        column-gap: 0.5rem;
    }

    .detail{
        border-right:1.5px solid var(--darkgrey);
        padding-right:0.5rem;
        font-size: 0.8rem;
        color:var(--darkgrey);
    }

    .detail:last-child{
        border-right:0px;
    }

    @media(max-width:768px) {
         .fullname{
        margin-top:0.8rem;
        font-size: 0.8rem;
    }

    .title{
        font-weight: bold;
         font-size: 0.6rem;
    }

    .details{
         white-space:nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
    }

    .detail{
        white-space:nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        font-size:0.6rem;
        border-right:1px solid var(--darkgrey);
    }

    .detail:last-child{
        border-right:0px;
    }
    }
</style>